// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IFieldStateType } from './IFieldStateType';
import {
    IFieldStateTypeFromJSON,
    IFieldStateTypeFromJSONTyped,
    IFieldStateTypeToJSON,
    IFieldStateTypeToJSONTyped,
} from './IFieldStateType';

/**
 * 
 * @export
 * @interface ICardOfferedInfoDto
 */
export interface ICardOfferedInfoDto {
    /**
     * 
     * @type {boolean}
     * @memberof ICardOfferedInfoDto
     */
    card_offered: boolean;
    /**
     * 
     * @type {IFieldStateType}
     * @memberof ICardOfferedInfoDto
     */
    card_offered_state?: IFieldStateType;
}



/**
 * Check if a given object implements the ICardOfferedInfoDto interface.
 */
export function instanceOfICardOfferedInfoDto(value: object): value is ICardOfferedInfoDto {
    if (!('card_offered' in value) || value['card_offered'] === undefined) return false;
    return true;
}

export function ICardOfferedInfoDtoFromJSON(json: any): ICardOfferedInfoDto {
    return ICardOfferedInfoDtoFromJSONTyped(json, false);
}

export function ICardOfferedInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICardOfferedInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'card_offered': json['card_offered'],
        'card_offered_state': json['card_offered_state'] == null ? undefined : IFieldStateTypeFromJSON(json['card_offered_state']),
    };
}

export function ICardOfferedInfoDtoToJSON(json: any): ICardOfferedInfoDto {
    return ICardOfferedInfoDtoToJSONTyped(json, false);
}

export function ICardOfferedInfoDtoToJSONTyped(value?: ICardOfferedInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'card_offered': value['card_offered'],
        'card_offered_state': IFieldStateTypeToJSON(value['card_offered_state']),
    };
}

